import onboardingFrame1 from './frame1.png';
import onboardingFrame2 from './frame2.png';
import onboardingFrame3 from './frame3.png';
import onboardingFrame4 from './frame4.png';
import onboardingFrame5 from './frame5.png';
import onboardingFrame6 from './frame6.png';

export const ElectroniumOnboardingImages = [
  onboardingFrame1,
  onboardingFrame2,
  onboardingFrame3,
  onboardingFrame4,
  onboardingFrame5,
  onboardingFrame6,
];
